exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".field[data-v-1bd2c19c]{width:75%;display:flex;flex-direction:column}.cards-container[data-v-1bd2c19c]{display:flex;flex-direction:column;justify-content:center}.notifications-container[data-v-1bd2c19c]{height:60px}.card-row[data-v-1bd2c19c]{display:flex;justify-content:center}.cta[data-v-1bd2c19c]{margin-top:3em}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1bd2c19c","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/PlayingField.vue
// module id = 45
// module chunks = 0